import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { salesOrderAvaTaxTable } from "../../../config/grid-column-defs";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import { GridComp6 } from "../../../components/GridComponents";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import { Box, Grid, Tabs, Tab, CircularProgress } from "@mui/material";
import TabPanel from "../../../components/TabPanel";
import { getTransactionSalesOrderAvatax } from "../../../api/transaction-type";
import { CustomCheckBox } from "../../../components/CheckboxComp";

export default function InvoiceAvaTax({ tabIndexP }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState({});
  const [subtabIndex, setSubtabIndex] = useState(0);

  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

 

  async function getTransactionAvataxLogData(limit, offset) {
    try {
      const { data } = await getTransactionSalesOrderAvatax(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setRowData( data.data)
      return {
        rows: data.data.data,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }
console.log(rowData,"row")
  return (
    <>
      <Box className="viewDetilsBox">
      <Grid container className="mb-2">
          <GridComp6
            title={"AVATAX DOCUMENT NUMBER"}
            data={rowData.avatax_document_number}
          />
          <GridComp6 title={"TOTAL DISCOUNT"} data={rowData.total_discount} />
          <GridComp6
            title={"DOCUMENT DATE"}
            data={rowData.document_date}
          />
          <GridComp6
            title={"TOTAL NON-TAXABLE"}
            data={rowData.total_non_taxable}
          />
          <GridComp6
            title={"DOCUMENT STATUS"}
            data={rowData.document_status}
          />
          <GridComp6
            title={"TOTAL TAXABLE"}
            data={rowData.total_taxable}
          />
          <GridComp6
            title={"TAX CALCULATION DATE"}
            data={rowData.tax_calculation_date}
          /><GridComp6
          title={"TOTAL TAX"}
          data={rowData.total_tax}
        /><GridComp6
        title={"TOTAL AMOUNT"}
        data={rowData.total_amount}
      />
          {/* <GridComp4
            title={"OPENAIR INVOICE NUMBER"}
            data={rowData.openair_invoice_number}
          />
          <GridComp4
            title={"OPENAIR: INVOICE LINK"}
            data={rowData.openair_invoice_link}
          />
          <GridComp4
            title={"OPENAIR: EXPORT ERROR (2)"}
            data={rowData.openair_export_error}
          />
          <CustomCheckBox title={"HELIX"} data={rowData.helix} />
          <GridComp4 title={"BUSINESS UNIT"} data={rowData.business_unit} />
          <CustomCheckBox
            title={"DO NOT MIGRATE TO QUORUM"}
            data={rowData.do_not_migrate_to_quorum}
          /> */}
        </Grid>
        <Box
          className="viewBox sub-tab"
          sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: "#fff" }}
        >
          <Tabs
            value={subtabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setSubtabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-bkg1"
          >
            <Tab label="Logs" />
          </Tabs>

          {/*avatax log*/}
          <TabPanel value={subtabIndex} index={0}>
            <AgGridPaginatedTable
              getTableRows={getTransactionAvataxLogData}
              columns={salesOrderAvaTaxTable}
              perPage={5}
              refreshCounter={0}
            />
          </TabPanel>
          {/*avatax log*/}
        </Box>
      </Box>
    </>
  );
}
